import { useRef, useEffect, useState } from 'react';
import Lottie from 'lottie-react';

interface LottieResponsiveProps {
  animationData: object;
  height: number;
  className?: string;
}

export function LottieResponsive({ animationData, height, className }: LottieResponsiveProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    const containerElement = containerRef.current;
    if (!containerElement) return;

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0]) {
        setWidth(entries[0].contentRect.width);
      }
    });

    resizeObserver.observe(containerElement);
    setWidth(containerElement.offsetWidth);
    return () => {
      resizeObserver.unobserve(containerElement);
      resizeObserver.disconnect();
    };
  }, []);

  if (!width) {
    return (
      <div
        ref={containerRef}
        className={`w-full ${className ?? ''}`}
        style={{ height: `${height}px` }}
      />
    );
  }

  return (
    <div
      ref={containerRef}
      className={`w-full ${className ?? ''}`}
      style={{ height: `${height}px` }}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        style={{ width: '100%', height: `${height}px` }}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice'
        }}
      />
    </div>
  );
}
